var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 46,
    viewBox: "0 0 92 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_5655)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2279_5655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2279_5655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.4375 0H0.4375V45.92H91.4375V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2279_5655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2279_5655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4375 0H0.4375V45.6978H91.4375V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2279_5655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2734 35.9573V35.6692H46.8039V31.1208H46.2734V30.8343H49.1733V30.6172H49.4985V31.853H49.1801V31.1917H47.505V33.1789H48.8411V32.5929H49.1646V34.1221H48.8411V33.5286H47.505V35.6096H49.2449V34.9256H49.5685V35.9573H46.2734Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0487 31.1243V36.0436H67.7462L65.0337 31.9448V35.6708H65.5721V35.9589H64.1473V35.6708H64.6824V31.4184L64.4918 31.1243H64.0039V30.8359H65.1669L67.6935 34.6407V31.1243H67.1568V30.8359H68.5764V31.1243H68.0487Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9902 36.0574C59.6927 36.0574 58.668 34.8468 58.668 33.4038C58.668 31.9431 59.6856 30.7422 60.9902 30.7422C62.2721 30.7422 63.2915 31.9528 63.2915 33.3979C63.2915 34.8409 62.2719 36.0574 60.9902 36.0574ZM60.9973 31.1458C60.0722 31.1458 59.4478 32.0778 59.4478 33.3979C59.4478 34.7086 60.072 35.6539 60.9902 35.6539C61.8943 35.6539 62.5114 34.7006 62.5114 33.3979C62.5114 32.0931 61.8943 31.1458 60.9973 31.1458Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4084 35.9589V35.6708H43.9373V31.8545L42.2069 36.0358L40.3892 31.7679V35.6708H40.9261V35.9589H39.5V35.6708H40.0343V31.1223H39.5V30.8359H40.7503L42.3818 34.662L43.9863 30.8359H45.1701V31.1223H44.6395V35.6708H45.1701V35.9589H43.4084Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8125 35.9589V35.6708H51.3424V31.1223H50.8125V30.8359H52.5751V31.1223H52.0452V35.6111H53.7013V34.9271H54.0249V35.9589H50.8125Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8828 35.9589V35.6708H55.4127V31.1223H54.8828V30.8359H56.6456V31.1223H56.1157V35.6111H57.7735V34.9271H58.097V35.9589H54.8828Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3115 31.1203L34.9555 33.5511V35.6688H35.4914V35.9569H33.7288V35.6688H34.2595V33.5991L32.7933 31.1203H32.3867V30.8359H34.2132V31.1203H33.6221L34.8069 33.1169L35.9095 31.1203H35.2649V30.8359H36.677V31.1203H36.3115Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2804 33.267C25.7841 33.3285 26.5446 33.6552 26.5446 34.6254C26.5446 35.444 25.9502 35.9589 25.1056 35.9589H22.8438V35.6708H23.3743V31.1223H22.8438V30.8359H24.9815C25.7255 30.8359 26.3183 31.2797 26.3183 32.1081C26.3183 32.7884 25.7841 33.1747 25.2804 33.2494V33.267ZM24.7052 31.1933H24.0774V33.1265H24.6668C25.1057 33.1265 25.5803 32.8248 25.5803 32.1387C25.5803 31.4644 25.1912 31.1933 24.7052 31.1933ZM24.7333 33.4763H24.0774V35.6111H24.7333C25.326 35.6111 25.8218 35.2596 25.8218 34.5852C25.8216 33.8857 25.3591 33.4763 24.7333 33.4763Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3993 31.1243V36.0436H31.0985L28.3863 31.9448V35.6708H28.9222V35.9589H27.4955V35.6708H28.034V31.4184L27.8434 31.1243H27.3555V30.8359H28.5175L31.0461 34.6407V31.1243H30.5092V30.8359H31.9291V31.1243H31.3993Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2529 14.2734C45.5019 15.2966 43.9418 16.6312 42.6562 18.0301C43.9104 19.382 45.3716 20.6761 47.2529 21.7859L55.9956 18.0301L47.2529 14.2734Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0929 17.3961C40.1271 15.0999 38.7882 12.5239 38.1133 10.3516L47.0059 14.1708C45.4018 14.8865 43.6913 15.9799 42.0929 17.3961Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0929 18.6719C40.1271 20.9683 38.7882 23.5452 38.1133 25.7181L47.0059 21.8974C45.4018 21.1826 43.6913 20.0892 42.0929 18.6719Z",
    fill: "#1F2022"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_5655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 45.92,
    fill: "white",
    transform: "translate(0.4375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2279_5655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 45.92,
    fill: "white",
    transform: "translate(0.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBny);
export default __webpack_public_path__ + "static/media/bny.0e08fe98f85c2955319af4f3453b84a5.svg";
export { ForwardRef as ReactComponent };